import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import lottie from 'lottie-web';

@Component({
  selector: 'app-redirect-page',
  templateUrl: './redirect-page.component.html',
  styleUrls: ['./redirect-page.component.scss'],
})
export class RedirectPageComponent implements OnInit, AfterViewInit {
  @ViewChild('lottieContainer') lottieContainer!: ElementRef;
  private animation: any;
  point: any;
  redirecturl: any;
  private redirectionTimeout: any;
  showCancelButton: boolean = true;
  showRedirectingText: boolean = true;
  showRedirectingHeader: boolean = true;
  showContinueButton: boolean = false;
  countdown: number = 10;

  constructor(private route: ActivatedRoute) {
    this.point = this.route.snapshot.queryParamMap.get('point');
    var encurl = this.route.snapshot.queryParamMap.get('encurl');
    this.redirecturl = encurl ? decodeURIComponent(encurl) : '';
  }

  ngOnInit(): void {
    this.startCountdown();
    this.startRedirectionTimer();
  }

  startCountdown(): void {
    const interval = setInterval(() => {
      if (this.countdown > 1) {
        this.countdown--;
      } else {
        clearInterval(interval);
      }
    }, 1000);
  }

  startRedirectionTimer(): void {
    this.redirectionTimeout = setTimeout(() => {
      this.redirectToTarget();
    }, 10000);
  }

  cancelRedirection(): void {
    if (this.redirectionTimeout) {
      clearTimeout(this.redirectionTimeout);
      this.redirectionTimeout = null;
      console.log('Redirection canceled.');
    }
    this.showCancelButton = false;
    this.showRedirectingHeader = false;
    this.showContinueButton = true;
  }

  continueRedirection(): void {
    this.redirectToTarget();
  }

  redirectToTarget(): void {
    window.location.href = this.redirecturl;
  }

  ngAfterViewInit(): void {
    this.animation = lottie.loadAnimation({
      container: this.lottieContainer.nativeElement,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/assets/animations/redirect.json',
    });

    this.animation.addEventListener('data_ready', () => {
      console.log('Animation loaded successfully');
    });

    this.animation.addEventListener('error', (error: any) => {
      console.error('Animation error:', error);
    });
  }
}
